<template>

    <el-button type="primary" v-if="loading" icon="el-icon-loading" disabled></el-button>
    <el-button type="primary" @click="onSubmit" v-else>确认</el-button>
</template>

<script>
    import bus from './bus';

    export default {
        name: 'submitBtn',
        created() {

            // 接收http.js文件传来的通知
            bus.$on('btnStatus', msg => {
                this.loading = msg;
            });

        },
        data() {
            return {
                loading: false
            };
        },
        props: {
            // 发送数据
            'data': {},
            // 验证规则
            'rules': {},
            // 请求路径
            'url': '',
            // 是否需要数据转换
            'JSON_Boolean': Boolean
        },
        methods: {
            // 提交
            onSubmit() {
                this.loading = true;

                if (this.JSON_Boolean) {
                    this.$emit('toJSON');
                }
                this.$nextTick(() => {
                    this.$post(
                        this.url,
                        this.data,
                        this.rules
                    ).then(res => {
                        this.$message.success(res.msg);
                        // 触发父组件自定义事件刷新表格
                        this.$emit('onSubmitDig');
                        this.loading = false;
                    });
                });


            }
        }
    };

</script>

<style scoped>

</style>